import { Link } from "react-router-dom";
import GlobalHelmetProvider from "../components/global/GlobalHelmetProvider";

const PageNotFound = ({ text = "This page doesn't exist" }: { text?: string }) => (
  <main className="page not-found">
    <GlobalHelmetProvider title="Not found" description={text} />
    <p className="not-found-code">404</p>
    <h1>{text}</h1>
    <p>
      <Link to="/videos">See all videos</Link> or <Link to="/">go home</Link>.
    </p>
  </main>
);

export default PageNotFound;
